import { defineStore } from 'pinia';
import { State } from '@/store/editor/types';
import { state } from './state';
import { actions } from './actions';

export const useEditorStore = defineStore('editor', {
  state: (): State => state,
  actions,
});
